// NOA Terms of Use — Pre-Launch
// Verbatim content, do not edit.
// Source: NOA_TERMS_OF_USE_UAE_PRELAUNCH_FINAL.md
export const TERMS_MARKDOWN = `# NOA Terms of Use — Pre-Launch

**Effective date:** September 2, 2026
**Last updated:** September 2, 2026

> Pre-launch notice: NOA is currently a pre-launch technology project operated through https://noatech.ae. Formal UAE business registration and licensing are pending. These Terms are intended for development, testing, preview, and pre-launch use and should be reviewed by UAE-qualified legal counsel before commercial launch.

## 1. About NOA
NOA is a pre-launch technology project providing smart-home, property-management, sustainability, community, and AI-assisted digital features.

Website: https://noatech.ae
Support / legal contact: noatech.support@gmail.com
Country of operation: United Arab Emirates

NOA is not currently represented as a registered UAE company in these Terms.

## 2. Pre-launch status
The Services may be incomplete, under development, unavailable, changed, or disabled without notice during the pre-launch period.

No feature should be treated as commercially available, safety-certified, regulator-approved, or production-ready unless expressly stated.

Paid subscriptions, billing, or commercial services should not be offered until the appropriate UAE business registration, licensing, payment arrangements, and legal review are in place.

## 3. Eligibility and authority
You must have legal capacity to use NOA. If you access NOA for a property, household, organisation, employer, owner, manager, tenant, contractor, or other person, you must have lawful authority to access and manage the relevant information, devices, permissions, and property.

## 4. Accounts and security
You are responsible for accurate account information, protecting credentials, securing your device, reporting suspected unauthorised access, and reviewing permissions granted to other users.

We may restrict or suspend access where reasonably necessary to protect users, property, devices, data, or systems.

## 5. Smart-home and IoT services
NOA may display, monitor, or control compatible third-party smart devices, including Tuya-compatible devices.

Smart-device functions depend on hardware, electricity, internet access, cloud platforms, gateways, firmware, APIs, and third-party providers. NOA does not guarantee continuous, real-time, uninterrupted, or error-free device operation.

You should verify the physical state of a device before relying on a remote command.

### Safety-critical limitation
Unless expressly certified in writing in the future, NOA is not a life-safety, emergency, medical, fire, gas, alarm-monitoring, or other safety-certified system.

Do not rely exclusively on NOA for fire or smoke detection, gas or carbon-monoxide safety, emergency medical alerts, critical access control, intrusion or security response, or any other safety-critical purpose.

Keep manufacturer safety systems, alarms, manual controls, emergency procedures, and legally required systems active.

## 6. Property Manager features
Property owners and managers are responsible for ensuring they have lawful authority over each property and for assigning, reviewing, and revoking access permissions appropriately.

They are also responsible for lawfully handling tenant, resident, employee, maintenance, contractor, document, certificate, and property information.

## 7. AI features
NOA may include AI-assisted interfaces, summaries, recommendations, explanations, or conversational features.

AI output may be incomplete, inaccurate, outdated, or unsuitable for your circumstances. It is not a substitute for qualified legal, medical, engineering, financial, fire-safety, security, or other professional advice.

Where AI runtime is not yet enabled, NOA may display AI interface elements without providing live model execution.

## 8. Automations and remote commands
Automations and device commands may fail, be delayed, or execute incorrectly because of network, cloud, device, software, permission, or provider conditions.

Do not configure automations where failure could reasonably cause death, injury, serious property damage, unlawful access, or another serious safety risk.

## 9. NOA World and community features
If NOA provides community, sustainability, challenge, or user-generated-content features, users must not upload or share unlawful, abusive, deceptive, infringing, malicious, or privacy-violating content.

We may remove content or restrict access where reasonably necessary to protect users or comply with applicable law.

## 10. Photos, certificates, files, and documents
You must have the right to upload any photo, certificate, maintenance record, invoice, document, or other file.

A NOA-generated verification page, QR code, digital record, or certificate does not itself guarantee legal validity, regulatory approval, authenticity, or third-party certification unless expressly stated.

## 11. Third-party services
NOA may rely on third-party services such as Supabase, Tuya and Tuya-compatible device platforms, hosting and cloud providers, communications, analytics, AI, mapping, support, Apple, Google, and app-distribution platforms.

Third-party services are subject to their own terms and availability.

## 12. Payments and subscriptions
NOA should not be treated as offering paid commercial services until the appropriate UAE registration, licensing, payment setup, disclosures, and consumer-protection requirements are completed.

If paid services are introduced later, the applicable price, billing period, renewal terms, taxes, cancellation process, and material restrictions will be shown before purchase.

## 13. Acceptable use
You must not use NOA unlawfully, access another user’s property, account, device, or data without permission, bypass access controls, facilitate unlawful surveillance, entry, fraud, harassment, or cybercrime, or intentionally compromise devices, systems, or networks.

## 14. Intellectual property
NOA branding, software, interface designs, documentation, and original content are owned by their respective creator(s) or licensors and are protected by applicable intellectual-property laws.

These Terms do not transfer ownership of NOA intellectual property to users.

## 15. Service availability
NOA is pre-launch and may change, suspend, or discontinue features during development and testing.

Some features may remain disabled until their backend, provider, legal, security, or production requirements are verified.

## 16. Privacy
Our processing of personal data is described in the NOA Privacy Policy:
https://noatech.ae/privacy

## 17. Consumer rights
Nothing in these Terms excludes or restricts rights that cannot lawfully be excluded under applicable UAE law.

## 18. Disclaimers
To the maximum extent permitted by applicable law, pre-launch Services are provided on an “as available” basis.

We do not guarantee uninterrupted availability, device compatibility, AI accuracy, third-party availability, or error-free operation.

## 19. Limitation of liability
Any limitation or exclusion of liability applies only to the extent permitted by applicable law.

Nothing in these Terms excludes liability where exclusion is prohibited by law.

A specific liability cap for future paid services should be reviewed by UAE legal counsel before commercial launch.

## 20. Suspension and termination
Access may be suspended or terminated for serious or repeated breaches, fraud, security risk, unlawful activity, or where required by law.

## 21. Governing law and disputes
These Terms are intended to operate under applicable laws of the United Arab Emirates.

The final governing-law, emirate, court, or free-zone jurisdiction clause should be completed after the appropriate UAE business registration and legal review.

## 22. Changes
These Terms may be updated as NOA develops, the operator structure changes, or applicable requirements change.

## 23. Contact
NOA — Pre-Launch Technology Project
Website: https://noatech.ae
Email: noatech.support@gmail.com
Country: United Arab Emirates
`;
